export default "__VITE_ASSET__DMsvSAIn__"